<div class="complex-value-container">
  <dl>
    @for (item of complexAttributeValue.items; track item) {
      <div class="sub-item">
        <dt class="sub-title">{{ item.name }}:</dt>
        <dd class="sub-value">
          @if (item.isLongAnswerType) {
            <div
              class="attribute-long-answer"
              [innerHTML]="item.value | safeHtml"
            ></div>
          }
          @if (item.isSkillType) {
            <skill
              [selectedSkillLevel]="
                item.subFieldValues[0]?.attributeDefinitionValueListItem
              "
            ></skill>
          }
          @if (item.isStarRatingType) {
            <app-star-rating-attribute
              [selectedStarRating]="
                item.subFieldValues[0]?.attributeDefinitionValueListItem
              "
            ></app-star-rating-attribute>
          }
          @if (
            !item.isSkillType &&
            !item.isStarRatingType &&
            !item.isLongAnswerType
          ) {
            @if (item.allowsMultiple) {
              @for (value of item.values; track value) {
                <p class="attribute-value">
                  {{ value }}
                </p>
              }
            }
            @if (!item.allowsMultiple) {
              <p class="attribute-value">{{ item.value }}</p>
            }
          }
        </dd>
      </div>
    }
  </dl>
</div>
